import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CenSpcOrderNotesDisabledState from "@tCentro/Store/Reducer/CenSpcOrderNotesDisabledState";
import { Draft } from "immer";

const initialState: CenSpcOrderNotesDisabledState = {
    isOrderNotesDisabledValue:true,
};

const reducer = {
    "Pages/OnePageCheckout/CenSpcIsOrderNotesDisabled": (draft: Draft<CenSpcOrderNotesDisabledState> ,
         action: {
            isOrderNotesDisabledValue: boolean;
    },) => {
        draft.isOrderNotesDisabledValue = action.isOrderNotesDisabledValue;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);